import { useState } from "react";
import axios from "axios";
import Utils from "../../Utils";

const DiscussionForm = ({ psId, attachmentId, threadId = 0, onSuccess }) => {
  const [comment, setComment] = useState("");
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!comment.trim()) return;

    const formData = new FormData();
    formData.append("psid", psId);
    formData.append("attachment_id", attachmentId);
    formData.append("thread_id", threadId);
    formData.append("comment", comment);

    if (file) {
      formData.append("attachment", file); // ✅ API key
    }

    try {
      setSubmitting(true);

      const res = await axios.post(Utils.apiUrl("photoshoot/attachment/discussion"), formData, {
        ...Utils.apiHeaders(),
        headers: {
          ...Utils.apiHeaders().headers,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.success) {
        setComment("");
        setFile(null);
        onSuccess && onSuccess();
      }
    } catch (err) {
      console.error("Discussion submit failed", err);
      alert("Failed to post discussion");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mt-3">
      <textarea
        className="w-full border rounded p-2 text-sm"
        placeholder="Add a comment…"
        value={comment}
        rows={3}
        onChange={(e) => setComment(e.target.value)}
      />

      <div className="flex justify-between items-center mt-2 gap-2">
        <input type="file" className="text-sm" accept=".pdf,.doc,.docx,.ppt,.pptx" onChange={(e) => setFile(e.target.files[0])} />

        <button onClick={submit} disabled={submitting} className="bg-blue-600 text-white px-4 py-1 rounded text-sm disabled:opacity-60">
          <i className="fas fa-paper-plane mr-1"></i>
          {submitting ? "Posting…" : "Post"}
        </button>
      </div>
    </div>
  );
};

export default DiscussionForm;
